<script setup lang="ts">
import { computed, ref, toRef } from "vue";
import DRBanner from "../UI/DRBanner.vue";
import PingMapImg from "/images/illustrations/map.png";
import ImportReportsDialog from "./ImportReportsDialog.vue";
import { useCreateDiagnostic } from "@/stores/queries";
import { useRouter } from "vue-router";
import { useTranslation } from "i18next-vue";

const { t } = useTranslation();
const props = defineProps<{
  projectId: number;
}>();

const projectId = toRef(props, "projectId");

const show = ref(false);

const { mutate: createDiagnostic } = useCreateDiagnostic(projectId);
const router = useRouter();

const handleCreate = () => {
  createDiagnostic(undefined, {
    onSuccess: (diagnostic) => {
      router.push({ name: "diagnostic", params: { id: diagnostic.id } });
    },
  });
};

const actions = computed(() => [
  {
    label: t("dashboard:diagnostic.banner.importPdf.title"),
    description: t("dashboard:diagnostic.banner.importPdf.description"),
    handler: () => {
      show.value = true;
    },
  },
  {
    label: t("dashboard:diagnostic.banner.createFirst.title"),
    description: t("dashboard:diagnostic.banner.createFirst.description"),
    handler: () => {
      handleCreate();
    },
  },
]);
</script>

<template>
  <DRBanner
    class="mb-3"
    :img="PingMapImg"
    :title="$t('report:diagnostics.banner.title')"
    :actions="actions"
  />

  <ImportReportsDialog v-model="show" :projectId="projectId" />
</template>
